import { axiosInstances } from '../../../../utilities/axios/Instances/axios.instances';
const list = () => {
  return axiosInstances.withAuthToken().get(`/auth/permissions`);
};
export const permissionsService = { list };
